
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useEbisInterfaceMonitoringMaintenanceVM } from "presentation/hook/EbisInterfaceMonitoring/useEbisInterfaceMonitoringMaintenanceVM";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import EbisInterfaceMonitoringDetailTablePanel from "./Detail/EbisInterfaceMonitoringDetailTablePanel";
import EbisInterfaceMonitoringTablePanel from "./EbisInterfaceMonitoringTablePanel";
import EbisInterfaceMonitoringTitleBar from "./EbisInterfaceMonitoringTitleBar";
import { EbisInterfaceMonitoringMainSearchPanel } from "./LeftPanel/EbisInterfaceMonitoringMainSearchPanel";

const EbisInterfaceMonitoringMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const ebisInterfaceMonitoringVM = useEbisInterfaceMonitoringMaintenanceVM();
    const { isShowSearchPanel, isShowDetailPanel } = ebisInterfaceMonitoringState;


    useEffect(() => {
        const initialScreen = async () => {
            ebisInterfaceMonitoringVM.setIsSearchLoading(true);
            setIsLoading(true);
            await Promise.allSettled([
                ebisInterfaceMonitoringVM.loadDropdownOption(),
            ]);
        }
        initialScreen().then(() => {
            let searchCriteria = { ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA };
            searchCriteria = {
                ...searchCriteria,
                dateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                dateTo: moment().endOf("day").toDate(),
                // dateFrom: moment().subtract(8, "years").startOf("day").toDate(),
                // dateTo: moment().endOf("day").toDate(),
            };
            ebisInterfaceMonitoringVM.onSearch(searchCriteria).then((data) => {
                setIsLoading(false);
                ebisInterfaceMonitoringVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                ebisInterfaceMonitoringVM.setIsSearchLoading(false);
            });
        }).catch(error => {
            setIsLoading(false);
            ebisInterfaceMonitoringVM.setIsSearchLoading(false);
        });

    }, [ebisInterfaceMonitoringVM])


    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {isShowDetailPanel && <><EbisInterfaceMonitoringDetailTablePanel /></>}
            {!isShowDetailPanel && <><EbisInterfaceMonitoringTitleBar />
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                    rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                    leftChildren={<EbisInterfaceMonitoringMainSearchPanel />}
                    rightChildren={<EbisInterfaceMonitoringTablePanel />}
                />
            </>
            }
        </div>
    </>
}

export default memo(EbisInterfaceMonitoringMaintenance);